import React, { type ReactNode } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useAiObservabilityAccess } from '../features/aiObservability/useAiObservabilityAccess';

interface AiObservabilityAccessGuardProps {
    children: ReactNode;
    requireManageSettings?: boolean;
}

export const AiObservabilityAccessGuard: React.FC<AiObservabilityAccessGuardProps> = ({ children, requireManageSettings = false }) => {
    const access = useAiObservabilityAccess(requireManageSettings);

    if (access === 'checking') {
        return (
            <Box role="status" aria-live="polite" sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress size={28} aria-label="Checking AI observability access" />
            </Box>
        );
    }

    if (access === 'denied') {
        return (
            <Box sx={{ p: { xs: 2, md: 3 } }}>
                <Alert severity="error">
                    {requireManageSettings
                        ? 'Access denied. Administrator, session-view and settings-management permissions are required.'
                        : 'Access denied. Administrator and session-view permissions are required.'}
                </Alert>
            </Box>
        );
    }

    return <>{children}</>;
};
